import { computed as b, toValue as u, watch as p } from "vue";
import { a as P } from "./keyField-D6okV6nC.js";
const Q = "[vue-virtual-scroller] `sizeDependencies` is deprecated and will be removed in the next major release. Dynamic item sizing uses ResizeObserver in modern browsers.";
let U = !1;
function R(l) {
  l == null || U || (U = !0, console.warn(Q));
}
function q(l, d, i, M) {
  let z = null, h = null, D = null, o = !1, a = null;
  const f = [], C = i.resizeObserver ? () => {
  } : i.onVscrollUpdate($), r = b(() => {
    const e = u(l);
    if (i.vscrollData.simpleArray) {
      if (e.index == null)
        throw new Error("index is required when using simple-array mode with dynamic item measurement");
      return e.index;
    }
    return P(e.item, e.index, i.vscrollData.keyField);
  }), S = b(() => i.vscrollData.sizes[r.value] || 0), t = b(() => u(l).active && i.vscrollData.active);
  function v() {
    t.value ? h !== r.value && (h = r.value, z = null, D = null, A(r.value)) : z = r.value;
  }
  function w() {
    u(l).watchData && !i.resizeObserver ? a = p(() => u(l).item, () => {
      _();
    }, {
      deep: !0
    }) : a && (a(), a = null);
  }
  function $({ force: e }) {
    !t.value && e && (D = r.value), (z === r.value || e || !S.value) && v();
  }
  function _() {
    v();
  }
  function c(e) {
    i.undefinedMap[e] && i.undefinedSizeCount.value--, i.undefinedMap[e] = void 0;
  }
  function O(e, n) {
    if (i.vscrollData.sizes[e]) {
      c(e);
      return;
    }
    if (n) {
      i.undefinedMap[e] || i.undefinedSizeCount.value++, i.undefinedMap[e] = !0;
      return;
    }
    i.undefinedMap[e] && (i.undefinedSizeCount.value--, i.undefinedMap[e] = !1);
  }
  function A(e) {
    i.measureQueue.schedule(e, {
      read() {
        if (r.value !== e)
          return null;
        const n = u(d);
        return n ? {
          width: n.offsetWidth,
          height: n.offsetHeight
        } : null;
      },
      write(n) {
        const { width: s, height: m } = n;
        V(s, m);
      },
      done() {
        h = null;
      }
    });
  }
  function V(e, n) {
    const s = ~~(i.direction.value === "vertical" ? n : e);
    s && S.value !== s && W(s);
  }
  function W(e) {
    var n, s;
    c(r.value), i.vscrollData.sizes[r.value] = e, u(l).emitResize && ((s = (n = u(M)) == null ? void 0 : n.onResize) == null || s.call(n, r.value));
  }
  function y() {
    if (!i.resizeObserver || o)
      return;
    const e = u(d);
    e && (i.resizeObserver.observe(e), e.$_vs_id = r.value, e.$_vs_onResize = N, o = !0);
  }
  function E() {
    if (!i.resizeObserver || !o)
      return;
    const e = u(d);
    e && (i.resizeObserver.unobserve(e), e.$_vs_onResize = void 0, o = !1);
  }
  function N(e, n, s) {
    r.value === e && V(n, s);
  }
  R(u(l).sizeDependencies), f.push(p(() => u(l).watchData, () => {
    w();
  })), f.push(p(() => u(l).sizeDependencies, (e) => {
    R(e), i.resizeObserver || _();
  }, {
    deep: !0
  })), f.push(p(r, (e, n) => {
    const s = u(d);
    s && (s.$_vs_id = e), c(n), O(e, t.value);
    const m = i.vscrollData.sizes[e];
    if (!m) {
      z = e, _();
      return;
    }
    c(e), o && (i.vscrollData.sizes[e] = m);
  })), f.push(p(t, (e) => {
    O(r.value, e), i.resizeObserver ? e ? y() : E() : e && D === r.value && v();
  })), w();
  function g() {
    t.value && (v(), y());
  }
  function H() {
    i.measureQueue.cancel(r.value), C(), E(), c(r.value);
    const e = u(d);
    e && (e.$_vs_id = void 0, e.$_vs_onResize = void 0), a && (a(), a = null);
    for (const n of f)
      n();
    f.length = 0;
  }
  return {
    id: r,
    size: S,
    finalActive: t,
    updateSize: v,
    mount: g,
    unmount: H
  };
}
export {
  q as c
};
//# sourceMappingURL=dynamicScrollerMeasurement-Cq5NQLJa.js.map
